import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/index';
import { useTranslation } from 'react-i18next';

const ReadAllOfProductSystemDownloadButton = (props) => {

  const productSystemId = props.productSystemId;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const deleteAllOfProdudctSystemUnreadInfo = (productSystemId) => dispatch( actions.deleteDocumentationFileUserInfoInProductSystem(productSystemId) );

    return (
       <a onClick={ () => { deleteAllOfProdudctSystemUnreadInfo(productSystemId) } } style={{marginRight: "0px", color: "white"}} className="btn btn-primary btn-project">{ t('button.downloads.all_read') }</a>
    )
}


export default ReadAllOfProductSystemDownloadButton;



// WEBPACK FOOTER //
// ./src/components/Documentations/ReadAllOfProductSystemDownloadButton.js